// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__Z36yE","content":"Hero_content__IZvFt","lightTheme":"Hero_lightTheme__lj5Z6","darkTheme":"Hero_darkTheme__kLlyV"};